import { Link } from "@tanstack/react-router";
import { useApi } from "@/src/lib/hooks/api/use-api";
import Icon from "../custom/Icon";
import UserDropdown from "./UserDropdown";

export default function DesktopNav() {
	const { auth, cart, orders } = useApi();

	const { data: session } = auth.useSession();
	const { data: cartData } = cart.getByUserId(session?.user?.id || "");
	const { data: ordersData } = orders.getByUserId({
		userId: session?.user?.id || "",
	});

	const cartItemCount = cartData?.cartItems?.length || 0;

	// Filter active orders (received, preparing, out-for-delivery)
	const activeOrders =
		ordersData?.orders?.filter((order) =>
			["received", "preparing", "out-for-delivery"].includes(order.status),
		) || [];

	const hasActiveOrders = activeOrders.length > 0;

	return (
		<div className="flex items-center gap-8">
			<div className="flex items-center gap-6">
				{hasActiveOrders && (
					<Link to="/orders" className="relative">
						<Icon
							name="Package"
							className="size-5 text-chart-1 hover:text-chart-1/80 transition-colors"
						/>
						<span className="absolute -top-2 -right-2 bg-chart-1 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
							{activeOrders.length > 99 ? "99+" : activeOrders.length}
						</span>
					</Link>
				)}
				<Link to="/cart" className="relative">
					<Icon
						name="ShoppingCart"
						className="size-5 text-muted-foreground hover:text-primary transition-colors"
					/>
					{cartItemCount > 0 && (
						<span className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
							{cartItemCount > 99 ? "99+" : cartItemCount}
						</span>
					)}
				</Link>
			</div>

			<UserDropdown />
		</div>
	);
}
